let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a0HiN")).then(() => parcelRequire('637hH'));